<!-- 仓库信息 -->
<template>
  <div class="nx-list-page stockmanagement-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="onSearchChange"
      @search-reset="onSearchReset"
      @refresh-change="onRefreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <div class="summaryInfo">
          <div class="summary-item summary-item--area">
            <span class="summary-item__label">库区总量：</span>
            <span class="summary-item__value">{{ formatNumber(summaryData.stockAreaCount) }}</span>
          </div>
          <div class="summary-item summary-item--location">
            <span class="summary-item__label">库位总量：</span>
            <span class="summary-item__value">{{ formatNumber(summaryData.locationCount) }}</span>
          </div>
          <div class="summary-item summary-item--current">
            <span class="summary-item__label">当前库存总量：</span>
            <span class="summary-item__value">{{ formatNumber(summaryData.totalCurrentWeight) }}</span>
            <span class="summary-item__unit">吨</span>
          </div>
          <div class="summary-item summary-item--out">
            <span class="summary-item__label">出库总量：</span>
            <span class="summary-item__value">{{ formatNumber(summaryData.totalOutWeight) }}</span>
            <span class="summary-item__unit">吨</span>
          </div>
          <div class="summary-item summary-item--in">
            <span class="summary-item__label">入库总量：</span>
            <span class="summary-item__value">{{ formatNumber(summaryData.totalInWeight) }}</span>
            <span class="summary-item__unit">吨</span>
          </div>
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, getDailyStockStatistics } from "./api";
import {
  getSettingDate
} from "@/util/date";
export default {
  name: "StockManagementBasic",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      summaryData: {},
      option: {
        ...this.$store.state.publicOption,
        labelWidth: 140,
        menu: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        column: [
          {
            label: "库区",
            prop: "stockCode",
            search: true,
            type: "select",
            remote: true,
            dicUrl: "/api/produce/store/select/distinct/pycode?storeName={{key}}",
            props: { label: "storeName", value: "storeNo" },
          },
          {
            label: "库位",
            prop: "locationCode",
            search: true,
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/location/select/distinct/pycode?locationName={{key}}",
            props: { label: "locationName", value: "locationCode" },

          },
          {
            label: "货主",
            search: true,
            prop: "custNo",
            type: "select",
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            overHidden: true,
          },
          {
            label: '煤种',
            prop: 'cargoNo',
            type: 'select',
            remote: true,
            search: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'varNo'
            },
          },
          {
            label: "当前库存量（吨）",
            prop: "currentWeight",
            overHidden: true,
            type: "number",
            precision: 2,
            min: 0.01,
            max: 99999,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "出库量（吨）",
            prop: "outWeight",
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "入库量（吨）",
            prop: "inWeight",
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: '查询日期',
            prop: 'endTime',
            overHidden: true,
            hide: true,
            type: 'date',
            searchValue: getSettingDate('now',{format: 'YYYY-MM-DD'}),
            value: getSettingDate('now',{format: 'YYYY-MM-DD'}),
            valueFormat: 'yyyy-MM-dd',
            search: true,
          }
        ],
      },
    };
  },
  mounted () {
    this.$nextTick(() => this.initCardData());
  },
  methods: {
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return '0';
      }
      return Number(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    initCardData () {
      const requestParams = {
        ...this.queryData
      };
      getDailyStockStatistics(requestParams).then(({ data }) => {
        this.summaryData = data.data || {};
      }).catch(() => {});
    },

    onSearchChange (params, done) {
      crudMixins.methods.searchChange.call(this, params, done);
      this.$nextTick(() => this.initCardData());
    },
    onSearchReset () {
      crudMixins.methods.searchReset.call(this);
      this.$nextTick(() => this.initCardData());
    },
    onRefreshChange () {
      crudMixins.methods.refreshChange.call(this);
      this.$nextTick(() => this.initCardData());
    },
  },
};
</script>
<style scoped lang="scss">
.stockmanagement-page {
  .summaryInfo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 16px;
  }

  .summary-item {
    display: inline-flex;
    align-items: baseline;
    flex-wrap: nowrap;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
  }

  .summary-item__label {
    color: #64748b;
    margin-right: 4px;
    white-space: nowrap;
  }

  .summary-item__value {
    font-size: 18px;
    font-weight: 600;
    margin-right: 2px;
  }

  .summary-item__unit {
    font-size: 13px;
    color: #64748b;
  }

  .summary-item--area {
    background: rgba(55, 65, 81, 0.08);
    .summary-item__value {
      color: #374151;
    }
  }

  .summary-item--location {
    background: rgba(37, 99, 235, 0.1);
    .summary-item__value {
      color: #2563eb;
    }
  }

  .summary-item--current {
    background: rgba(5, 150, 105, 0.12);
    .summary-item__value {
      color: #059669;
    }
  }

  .summary-item--out {
    background: rgba(194, 65, 12, 0.1);
    .summary-item__value {
      color: #c2410c;
    }
  }

  .summary-item--in {
    background: rgba(2, 132, 199, 0.1);
    .summary-item__value {
      color: #0284c7;
    }
  }
}
</style>
